// extracted by mini-css-extract-plugin
export var boderLine = "index-module--boderLine--921ff";
export var button = "index-module--button--33607";
export var clientBillingRateArea = "index-module--clientBillingRateArea--cccca";
export var clientBillingRateUnit = "index-module--clientBillingRateUnit--3fdc6";
export var defaultBorder = "index-module--defaultBorder--7ee7e";
export var defaultButton = "index-module--defaultButton--a436b";
export var disabledButton = "index-module--disabledButton--e172e";
export var discription = "index-module--discription--88fe8";
export var div1 = "index-module--div1--efc8e";
export var div10 = "index-module--div10--a6969";
export var div11 = "index-module--div11--44616";
export var div12 = "index-module--div12--eb3cc";
export var div13 = "index-module--div13--2bc52";
export var div14 = "index-module--div14--0932c";
export var div15 = "index-module--div15--759c5";
export var div16 = "index-module--div16--4aa74";
export var div17 = "index-module--div17--7b25d";
export var div18 = "index-module--div18--1429b";
export var div19 = "index-module--div19--8df21";
export var div2 = "index-module--div2--b6efc";
export var div20 = "index-module--div20--fbb22";
export var div3 = "index-module--div3--676a0";
export var div4 = "index-module--div4--737c8";
export var div5 = "index-module--div5--7419b";
export var div6 = "index-module--div6--f676a";
export var div7 = "index-module--div7--9c7bc";
export var div8 = "index-module--div8--5dd0d";
export var div9 = "index-module--div9--a2011";
export var errorBorder = "index-module--errorBorder--9d2b9";
export var errorText = "index-module--errorText--6e678";
export var errorTextArea = "index-module--errorTextArea--db41d";
export var form = "index-module--form--e7259";
export var inputForm = "index-module--inputForm--3e8fd";
export var label = "index-module--label--7ae50";
export var mainHead = "index-module--mainHead--bf9ae";
export var parent = "index-module--parent--44c0e";
export var result = "index-module--result--e0344";
export var selectBox = "index-module--selectBox--9d3a2";
export var selectBoxArea = "index-module--selectBoxArea--64598";
export var selectBoxForms = "index-module--selectBoxForms--19996";
export var selectBoxLabel = "index-module--selectBoxLabel--6d1b9";
export var simulation = "index-module--simulation--17a1b";
export var subHead = "index-module--subHead--9a3fe";
export var subText = "index-module--subText--595bd";
export var subTitle = "index-module--subTitle--3ed36";
export var text = "index-module--text--3c52b";
export var title = "index-module--title--769d1";
export var year = "index-module--year--ea6af";
export var yen = "index-module--yen--cbdf7";